import { useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import { getNoteCodes, getNoteSettings } from '@user/store/notes/api'
import { toast } from 'react-toastify'

export function useGetNoteSetting() {
  const dispatch = useAppDispatch()

  const fetchNoteSettings = async () => {
    try {
      const result = await dispatch(getNoteSettings())
      if (getNoteSettings.fulfilled.match(result)) {
        const { payload } = result
        return {
          defaultNoteCodeId: payload.defaultNoteCodeId ?? '',
          noteAutomationEnabled: payload.noteAutomationEnabled,
        }
      }
    } catch (error) {
      toast.error('Error retrieving Note settings')
    }

    return {
      defaultNoteCodeId: '',
      noteAutomationEnabled: false,
    }
  }

  const fetchNoteCodes = useCallback(async () => {
    try {
      const result = await dispatch(getNoteCodes())
      if (getNoteCodes.fulfilled.match(result)) {
        const { payload } = result
        return payload?.items || []
      }
    } catch (error) {
      toast.error('Error retrieving Note codes')
    }

    // fallback/default
    return []
  }, [])

  return { fetchNoteSettings, fetchNoteCodes }
}
